<template>
  <div>
    <div>
      <b-row class="mx-0 score-board">
        <b-col
          class="px-2 text-white d-flex justify-content-between align-items-center border-right border-white bg-main"
          ><label>ราคาสุทธิ</label
          ><label>{{ transaction.netPrice | numeral("0,0.00") }} บาท</label>
        </b-col>
        <b-col
          class="px-2 text-white d-flex justify-content-between align-items-center border-white bg-main"
          ><label>คะแนนรวม</label
          ><label>{{ transaction.point | numeral("0,0") }} คะแนน</label>
        </b-col>
      </b-row>
      <div class="p-2 detail-panel">
        <div class="d-flex">
          <b-input-group>
            <b-form-input
              id="product-search"
              class="input-serach"
              placeholder="หมายเลขสมาชิก / เบอร์โทรศัพท์"
              @keypress="handlePushMessage"
              @input="handleEmpty"
              v-model="filter.search"
            ></b-form-input>
          </b-input-group>
          <b-button class="search-circle-bth" @click="searchUser('search')"
            ><span class="icon-input m-auto pr-2">
              <font-awesome-icon icon="search" title="View" /> </span
          ></b-button>
        </div>
        <div class="mt-2" v-if="user.member_id">
          <div class="d-flex justify-content-between">
            <label class="text-general"
              >{{ user.first_name_th }} {{ user.last_name_th }}</label
            >
            <label class="text-general"
              >{{ user.point + user.center_point }} คะแนน</label
            >
          </div>
          <div class="d-flex justify-content-between">
            <label class="text-grey">{{ user.member_id }}</label
            ><label class="pointer text-main" @click="openSlideCustomer"
              ><u>แก้ไขข้อมูล</u></label
            >
          </div>
        </div>
      </div>
      <div class="mt-2 p-2 detail-panel">
        <b-row class="px-2">
          <b-col cols="6">
            <InputText
              textFloat="รหัสพนักงาน"
              v-model="form.saleId"
              placeholder="รหัสพนักงาน"
              type="text"
              :isValidate="$v.form.saleId.$error"
              :v="$v.form.saleId"
          /></b-col>
          <b-col cols="6">
            <InputText
              textFloat="หมายเลขบิล"
              v-model="form.invoiceNo"
              placeholder="หมายเลขบิล"
              type="text"
              :isValidate="$v.form.invoiceNo.$error"
              :v="$v.form.invoiceNo"
            />
          </b-col>
        </b-row>
      </div>
      <div class="p-2 detail-panel">
        <div class="d-flex justify-content-between">
          <div>
            <label class="header-text font-color">รายการสินค้า</label>
          </div>
          <b-button
            :disabled="!user.member_id"
            class="radius-btn bg-main"
            @click="openSlideProduct"
            ><font-awesome-icon
              icon="plus"
              title="create-btn"
              class="mr-0 mr-sm-1"
            /><span class="ml-1 text-general">เพิ่มสินค้า</span></b-button
          >
        </div>
        <b-row class="mx-0 mt-2">
          <b-col cols="2" class="pl-0"
            ><span class="text-general">จำนวน</span></b-col
          >
          <b-col cols="7"><span class="text-general">รายการสินค้า</span></b-col>
          <b-col cols="3" class="pr-0 text-right"
            ><span class="text-general">ราคา</span></b-col
          >
        </b-row>
        <div v-if="!user.member_id" class="text-center">
          <p class="pt-2 text-general">กรุณาเลือกสมาชิก</p>
        </div>

        <div v-else-if="form.product.length > 0">
          <b-row
            class="mx-0 my-1 p-2 bg-white product-panel"
            v-for="(product, index) in form.product"
            :key="index"
          >
            <b-col cols="2" class="text-center pl-0 pr-0 border-product"
              ><p @click="upProductQuantity(index)">
                <font-awesome-icon
                  icon="plus-circle"
                  title="up-btn"
                  class="pointer"
                />
              </p>
              <p>{{ product.quantity }}</p>
              <p @click="downProductQuantity(index)">
                <font-awesome-icon
                  icon="minus-circle"
                  title="down-btn"
                  class="pointer"
                /></p
            ></b-col>
            <b-col
              cols="8"
              class="px-2 pointer"
              @click="openSlideEditProduct(index)"
              ><p class="text-general">{{ product.barcode }}</p>
              <p class="text-general">{{ product.name }}</p>
            </b-col>
            <b-col
              cols="2"
              class="pr-0 pointer text-right"
              @click="openSlideEditProduct(index)"
              ><p>
                {{
                  product.sap_discount.id
                    ? product.priceSap
                    : product.price | numeral("0,0.00")
                }}
              </p>
              <p v-if="product.sap_discount.id">
                <del>
                  {{ product.price | numeral("0,0.00") }}
                </del>
              </p></b-col
            >
          </b-row>
        </div>
        <div v-else class="p-2 text-center text-general">
          <p>กรุณาเพิ่มสินค้า</p>
        </div>
      </div>
      <div class="mt-2 px-2 py-2 detail-panel">
        <div class="d-flex justify-content-between">
          <label class="header-text">ส่วนลดท้ายบิล</label>
          <label
            class="pointer color-primary text-general"
            @click="openSlideHeaderDiscount"
            ><u>ส่วนลดท้ายบิล</u></label
          >
        </div>
        <b-input-group class="mt-2">
          <b-form-input class="w-75" placeholder="ส่วนลดท้ายบิล"></b-form-input>
          <div
            class="w-25 bg-grey suffix-btn d-flex justify-content-center align-items-center"
          >
            บาท
          </div>
        </b-input-group>
      </div>
      <div class="mt-2 p-2 detail-panel header-text font-color">
        <div class="d-flex justify-content-between">
          <span>ราคารวม</span>
          <span>{{ transaction.price | numeral("0,0.00") }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>ส่วนลดรวม</span>
          <span>{{ transaction.discount | numeral("0,0.00") }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>ราคาสุทธิ</span>
          <span>{{ transaction.netPrice | numeral("0,0.00") }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>คะแนนที่ได้รับ</span>
          <span>{{ transaction.point | numeral("0,0") }} คะแนน</span>
        </div>
      </div>
      <div class="mt-2 text-center">
        <b-button class="radius-btn w-75" @click="checkForm">
          <span> ยืนยัน ({{ transaction.point | numeral("0,0") }} คะแนน) </span>
        </b-button>
        <br />
        <b-button class="text-secondary" @click="clearDetail" variant="link"
          >ลบรายการ</b-button
        >
      </div>
      <SlideCustomer
        ref="SlideCustomer"
        :search="filter.search"
        :user="user"
        @onChangehUser="changehUser"
        @onChangeUserData="changeUserData"
      />
      <SlideCustomerList
        ref="SlideCustomerList"
        :customerListObj="customerList"
        :search="filter"
        @onChangehUser="changehUser"
      />
      <SlideProduct
        ref="SlideProduct"
        :booth="isBooth"
        :spa="isSpa"
        v-on:onSelectProduct="addProduct"
      />
      <SlideEditProduct
        ref="SlideEditProduct"
        :user="user"
        :headerDiscountOption="headerDiscountOption"
        :headerDiscountSelectMain="headerDiscountSelect"
        @onOpenEditHeaderDiscountModal="openModalEditHeaderDiscount"
        @onEditProduct="editProduct"
      />
      <SlideHeaderDiscount
        ref="SlideHeaderDiscount"
        :headerDiscountOption="headerDiscountOption"
        :headerDiscountSelectIdList="headerDiscountSelect"
        @onOpenEditHeaderDiscountModal="openModalEditHeaderDiscount"
        @onSelectDiscount="selectDiscount"
      />
      <b-modal
        v-model="modalConfirmShow"
        hide-header
        hide-footer
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
      >
        <label>ยืนยันการสั่งซื้อ</label>
        <div class="mt-2 p-2 detail-panel">
          <div class="px-1 d-flex justify-content-between">
            <span>ราคารวม</span>
            <span>{{ transaction.price | numeral("0,0.00") }}</span>
          </div>
          <div class="px-1 d-flex justify-content-between">
            <span>ส่วนลดรวม</span>
            <span>{{ transaction.discount | numeral("0,0.00") }}</span>
          </div>
          <div class="px-1 d-flex justify-content-between">
            <span>ราคาสุทธิ</span>
            <span>{{ transaction.netPrice | numeral("0,0.00") }}</span>
          </div>
          <div class="px-1 d-flex justify-content-between">
            <span>คะแนนที่ได้รับ</span>
            <span>{{ transaction.point | numeral("0,0") }} คะแนน</span>
          </div>
        </div>
        <b-row class="px-2 mt-3">
          <b-col cols="6" class="px-1">
            <b-button
              class="radius-btn bg-white w-100"
              :style="`color:${$store.state.colorSecondary};border: 1px solid ${$store.state.colorSecondary}`"
              @click="modalConfirmShow = false"
            >
              <span>ยกเลิก</span>
            </b-button>
          </b-col>
          <b-col cols="6" class="px-1">
            <b-button
              class="radius-btn w-100"
              :disabled="isDisabledSubmit"
              @click="submitForm"
            >
              <span>ยืนยัน</span>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        v-if="headerDiscountOption.length > 0"
        v-model="modalEditHeaderDiscount"
        hide-header
        hide-footer
        size="lg"
        centered
        no-close-on-backdrop
        no-close-on-esc
      >
        <div class="pb-2 d-flex justify-content-between align-items-center">
          <label>ปรับส่วนลด</label>
          <label class="pointer" @click="modalEditHeaderDiscount = false"
            ><b-icon icon="x-circle-fill"></b-icon
          ></label>
        </div>
        <div class="p-2 detail-panel text-general">
          <b-row>
            <b-col cols="10" class="justify-content-center align-items-center"
              ><InputText
                textFloat=""
                v-model="valueEdit"
                placeholder="0"
                type="number"
                :isValidate="$v.valueEdit.$error"
                :v="$v.valueEdit"
            /></b-col>
            <b-col
              cols="2"
              class="d-flex justify-content-left align-items-center"
              ><span class="text-header">{{
                headerDiscountOption[indexEdit].promotion_discount_type_id == 1
                  ? "%"
                  : "บาท"
              }}</span></b-col
            >
          </b-row>
          <p class="mt-2">
            <u @click="getHeaderDisCount">กลับสู่ค่าตั้งต้น</u>
          </p>
        </div>
        <b-row class="mt-2">
          <b-col cols="6">
            <b-button
              class="radius-btn bg-white w-100"
              :style="`color:${$store.state.colorSecondary};border: 1px solid ${$store.state.colorSecondary}`"
              @click="modalEditHeaderDiscount = false"
            >
              <span>ยกเลิก</span>
            </b-button>
          </b-col>
          <b-col cols="6">
            <b-button class="radius-btn w-100" @click="editheaderDiscount"
              ><span>ยืนยัน</span></b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <ModalLoading ref="modalLoading" :hasClose="false" />
    </div>
  </div>
</template>

<script>
import * as moment from "moment/moment";
import {
  required,
  requiredIf,
  minLength,
  minValue,
} from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";
import SlideCustomer from "./components/SlideCustomer.vue";
import SlideCustomerList from "./components/SlideCustomerList.vue";
import SlideProduct from "./components/SlideProduct.vue";
import SlideEditProduct from "./components/SlideEditProduct.vue";
import SlideHeaderDiscount from "./components/SlideHeaderDiscount.vue";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  name: "HomeIndex",
  components: {
    InputText,
    SlideCustomer,
    SlideCustomerList,
    SlideProduct,
    SlideEditProduct,
    SlideHeaderDiscount,
    ModalLoading,
  },
  data() {
    return {
      isBusy: false,
      filter: {
        search: "",
        page: 1,
      },
      user: {
        user_guid: "",
        user_id: "",
        member_id: "",
        first_name_th: "",
        last_name_th: "",
        telephone: "",
        point: 0,
        center_point: 0,
      },
      customerList: [],
      form: {
        saleId: "",
        invoiceNo: "",
        product: [],
        promotion: {
          headerDiscount: [],
        },
      },
      transaction: {
        price: 0,
        netPrice: 0,
        discount: 0,
        quantity: 0,
        point: 0,
      },
      headerDiscountSelect: [],
      headerDiscountOption: [],
      indexEdit: 0,
      valueEdit: 0,
      modalEditHeaderDiscount: false,
      isBooth: true,
      isSpa: true,
      modalConfirmShow: false,
      modalMessage: "",
      isDisabledSubmit: false,
    };
  },
  watch: {
    "form.product": {
      async handler(val) {
        if (val.length > 0) {
          this.calculateTransaction();
        }
        if (this.form.product.length <= 0) {
          this.form.promotion.headerDiscount = await [];
          this.headerDiscountSelect = [];
        }
      },
      deep: true,
    },
    headerDiscountSelect: {
      handler(val) {
        if (val.length > 0) this.calculateTransaction();
      },
      deep: true,
    },
  },
  validations: {
    form: {
      saleId: { required },
      invoiceNo: { required },
      product: { required, minLength: minLength(1) },
    },
    valueEdit: { required, minValueZero: minValue(0) },
  },
  async created() {
    this.getHeaderDisCount();
  },
  methods: {
    handleEmpty(e) {
      if (e == "") this.clearDetail();
    },
    toggleSidebar(type) {
      // this.clearDetail();
      let body = {
        search: this.filter.search,
        datetime: moment().add("years", 543).format("DD/MM/YYYY HH:mm:ss"),
        skip: 0,
        take: 5,
        branch_id: this.$cookies.get("branch_id"),
      };

      this.$refs.SlideCustomerList.show();
    },
    searchUser(type) {
      this.$refs.modalLoading.show();
      // this.clearDetail();
      let body = {
        search: this.filter.search,
        datetime: moment().add("years", 543).format("DD/MM/YYYY HH:mm:ss"),
        skip: 0,
        take: 5,
        branch_id: this.$cookies.get("branch_id"),
      };

      this.axios
        .post(`${this.$baseUrl}/customer/searchtelephone`, body)
        .then((data) => {
          if (data.result == 1) {
            this.customerList = data.detail;
            if (data.detail.length == 1) {
              this.user = data.detail[0];
              if (type == "changeUser") {
                setTimeout(() => {
                  this.$refs.SlideCustomer.show();
                }, 100);
              }
            } else if (data.detail.length == 0) {
              this.warningAlert("ไม่พบสมาชิก");
            } else {
              // this.filter.search = "";
              this.$refs.SlideCustomerList.show();
            }
          } else {
            this.warningAlert(data.message);
          }
          this.$refs.modalLoading.hide();
        });
    },
    handlePushMessage(e) {
      let value = e.target.value;
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.searchUser("search");
      }
    },
    changehUser(search, type) {
      // this.filter.search = search;
      this.user = type;
      console.log(type);
      this.getHeaderDisCount();
      // this.searchUser(type == "change" ? "changeUser" : "search");
    },
    getHeaderDisCount() {
      console.log(this.user.user_guid);
      this.axios
        .get(
          `${this.$baseUrl}/promotion/get_header_discount/${
            this.user.user_guid || " "
          }/${moment().format("YYYY-MM-DD HH:mm:ss")}/${this.$cookies.get(
            "branch_id"
          )}`
        )
        .then((data) => {
          this.headerDiscountOption = data.detail;
          this.valueEdit = data.detail[this.indexEdit].promotion_value;
          this.headerDiscountOption[this.indexEdit].promotion_value =
            data.detail[this.indexEdit].promotion_value;
        });
    },
    addProduct(body) {
      this.axios
        .post(`${this.$baseUrl}/product/product_lookup`, body)
        .then((data) => {
          if (data.result == 1) {
            data.detail.quantity = 1;
            data.detail.group_barcode = "";
            data.detail.sap_discount = { id: null };
            data.detail.item_discount = { id: null };
            this.form.product.push(data.detail);
          }
        });
    },
    upProductQuantity(index) {
      this.form.product[index].quantity += 1;
    },
    downProductQuantity(index) {
      if (this.form.product[index].quantity > 1) {
        this.form.product[index].quantity -= 1;
      } else {
        this.form.product.splice(index, 1);
      }
    },
    clearDetail() {
      this.user = {
        user_guid: "",
        user_id: "",
        member_id: "",
        first_name_th: "",
        last_name_th: "",
        telephone: "",
        point: 0,
        center_point: 0,
      };
      this.transaction = {
        price: 0,
        netPrice: 0,
        discount: 0,
        quantity: 0,
        point: 0,
      };
      this.form = {
        saleId: "",
        invoiceNo: "",
        product: [],
        promotion: {},
      };
      this.$v.$reset();
    },
    openSlideCustomer() {
      if (this.user.member_id) {
        this.$refs.SlideCustomer.show();
      }
    },
    openSlideProduct() {
      this.$refs.SlideProduct.show();
    },
    openSlideEditProduct(index) {
      this.$refs.SlideEditProduct.show(JSON.stringify(this.form), index);
    },
    openSlideHeaderDiscount() {
      if (this.form.product.length > 0) {
        this.$refs.SlideHeaderDiscount.show();
      }
    },
    async changeUserData(body) {
      this.axios
        .post(`${this.$baseUrl}/customer/check_duplicate_telephone`, body)
        .then((data) => {
          if (data.result == 1) {
            this.axios
              .post(`${this.$baseUrl}/customer/editdata`, body)
              .then((data) => {
                if (data.result == 1) {
                  this.user = body;
                  this.$refs.SlideCustomer.hide();
                } else {
                  this.warningAlert(data.detail);
                }
              });
          } else {
            this.warningAlert(data.detail);
          }
        });
    },
    editProduct(detail, index) {
      this.form.product[index].price = detail.product.price
        ? parseInt(detail.product.price)
        : 0;
      this.form.product[index].quantity = parseInt(detail.product.quantity);
      this.form.product[index].sap_discount.id = detail.promotion.id;
      detail.promotion.option.forEach((p, i) => {
        if (p.id == detail.promotion.id) {
          this.form.product[index].priceSap = p.promotion_value;
        }
      });
      this.form.product[index].item_discount.id = detail.itemDiscount;
      this.selectDiscount(detail.headerDiscount);
    },
    selectDiscount(list) {
      this.headerDiscountSelect = list.id;
      this.form.promotion.headerDiscount = list.detail;
    },
    async openModalEditHeaderDiscount(index) {
      this.indexEdit = await index;
      this.valueEdit = await this.headerDiscountOption[index].promotion_value;
      this.modalEditHeaderDiscount = true;
    },
    async editheaderDiscount() {
      this.$v.valueEdit.$touch();
      if (this.$v.valueEdit.$error) {
        return;
      } else {
        this.headerDiscountOption[this.indexEdit].promotion_value =
          await parseInt(this.valueEdit ? this.valueEdit : 0);
        if (this.form.promotion.headerDiscount.length >= this.indexEdit + 1) {
          this.form.promotion.headerDiscount[
            this.indexEdit
          ].custom_header_discount = await parseInt(
            this.valueEdit ? this.valueEdit : 0
          );
        }
        await this.$refs.SlideHeaderDiscount.resetCalculateList();
        await this.$refs.SlideEditProduct.resetCalculateList();
        this.$refs.modalLoading.show();
        await this.calculateTransaction();
        this.$refs.modalLoading.hide();
        this.modalEditHeaderDiscount = false;
      }
    },
    calculateTransaction() {
      let product = this.form.product.map((prod, index) => {
        return {
          id: prod.id,
          q: prod.quantity,
          custom_price: prod.price,
          group_barcode: "",
          sap_discount: prod.sap_discount.id
            ? [{ id: prod.sap_discount.id, custom_header_discount: null }]
            : null,
          item_discount: prod.item_discount.id
            ? [{ id: prod.item_discount.id, custom_header_discount: null }]
            : null,
        };
      });
      let body = {
        price: [],
        promotion: this.form.promotion.headerDiscount,
        product: product,
        credit: null,
        customer_id: this.user.user_guid,
        user_id: this.$cookies.get("user_guid"),
        user_guid: this.$cookies.get("user_guid"),
        debug: 0,
        branch_id: this.$cookies.get("branch_id"),
        t_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
      };
      this.axios
        .post(`${this.$baseUrl}/transaction/calculate_transaction_data`, body)
        .then((data) => {
          if (data.result == 1) {
            this.transaction = {
              price: data.price.price_with_no_discount,
              netPrice: data.price.price,
              discount: data.price.discount,
              quantity: data.quantity,
              point: data.center_point + data.point,
            };
          } else {
            this.transaction = {
              price: 0,
              netPrice: 0,
              discount: 0,
              quantity: 0,
              point: 0,
            };
          }
        });
    },
    checkForm() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      } else {
        this.modalConfirmShow = true;
      }
    },
    submitForm() {
      this.$refs.modalLoading.show();
      this.isDisabledSubmit = true;
      let product = this.form.product.map((prod, index) => {
        return {
          id: prod.id,
          q: prod.quantity,
          group_barcode: "",
          sap_discount: prod.sap_discount.id
            ? [{ id: prod.sap_discount.id, custom_header_discount: null }]
            : null,
          item_discount: prod.item_discount.id
            ? [{ id: prod.item_discount.id, custom_header_discount: null }]
            : null,
        };
      });
      let body = {
        price: [],
        promotion: this.form.promotion.headerDiscount,
        product: product,
        credit: null,
        user_guid: this.user.user_guid,
        debug: 0,
        branch_id: this.$cookies.get("branch_id"),
        t_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
        user_get_point: "1",
        new_customer: "0",
        tourist: "0",
        partner: "0",
        partner_detail: "",
        invoice_no: this.form.invoiceNo,
        zero_point: "0",
        sales_id: this.form.saleId,
      };
      this.axios
        .post(`${this.$baseUrl}/transaction/submit_transaction_data`, body)
        .then((data) => {
          if (data.result == 1) {
            this.modalConfirmShow = false;
            this.successAlert();
          } else {
            this.modalConfirmShow = false;
            this.warningAlert(data.message);
          }
          this.$refs.modalLoading.hide();
          this.isDisabledSubmit = false;
        })
        .catch(function (error) {
          this.$refs.modalLoading.hide();
          this.isDisabledSubmit = false;
          this.modalConfirmShow = false;
          this.warningAlert("ไม่สามารถทำรายการได้");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep label {
  font-weight: bold;
  margin-bottom: 0px;
  // color: #000000;
}
::v-deep p {
  margin-bottom: 0px;
}
::v-deep .modal-body {
  padding: 8px;
}
</style>
